import API from "../api";
export default {
  namespaced: true,
  state: {
    offices: { total_count: 0, items: [] },
    quotations: { total_count: 0, items: [] },
    policies: { total_count: 0, items: [] }
  },
  mutations: {
    setOffices(state, data) {
      state.offices = data;
    },
    setPolicies(state, payload) {
      state.policies = payload;
    },
    setQuotations(state, payload) {
      state.quotations = payload;
    }
  },
  actions: {
    async requestOfficeList({ commit }, payload) {
      const { data } = await API.getOfficeList(payload);
      commit("setOffices", data);
      return data;
    },
    async requestOffice(context, id) {
      const { data } = await API.getOffice(id);
      return data;
    },
    async requestEditOffice(context, { id, payload }) {
      const { data } = await API.putOffice({ id, payload });
      return data;
    },
    async requestCreateOffice(context, payload) {
      const { data } = await API.postOffice(payload);
      return data;
    },
    async requestListPolicy({ commit }, payload) {
      const { data } = await API.getListPolicy(payload);
      commit("setPolicies", data);
      return data;
    },
    async requestListQuotation({ commit }, payload) {
      const { data } = await API.getListQuotation(payload);
      commit("setQuotations", data);
      return data;
    }
  },
  modules: {}
};
